/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

import {ApiConfig} from "../../api";
import {Injectable} from "@angular/core";
import {AdnHttpService} from '../../../util/adn-http.service';
import {AdnHttpSender, createAdnHttpResourceSender} from '../../../util/create-adn-http-resource';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticatedUserResource {
  private readonly url = ApiConfig.obtain().getVersionedUri('user');
  private readonly verifyUrl = ApiConfig.obtain().getVersionedUri('user/2fa/verify');
  private readonly sendEmail2faCodeUrl = ApiConfig.obtain().getVersionedUri('user/send-email-2fa-code');
  private readonly cChangePasswordUrl = ApiConfig.obtain().getVersionedUri('user/change-password');
  private readonly send: AdnHttpSender;

  constructor(
    AdnHttp: AdnHttpService,
    authHttpInterceptor: AuthHttpInterceptorService,
    ApiErrorHandler: ApiErrorHandlerService
  ) {
    this.send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  }

  sendEmail2faCode(reason: string) {
    return this.send({method: 'GET', url: this.sendEmail2faCodeUrl, params: {reason}}).then(function() {
      return true;
    }).catch(function(response) {
      return {data: response.data};
    });
  }

  changePassword(currentPassword, newPassword, twoFactorAuthCode) {
    const data = {'password': currentPassword, 'newPassword': newPassword, 'twoFactorAuthCode': twoFactorAuthCode};
    return this.send({method: 'POST', url: this.cChangePasswordUrl, body: data}).then(function(response) {
      return {state: true, data: response};
    }).catch(function(response) {
      return response.data;
    });
  }

  verify2fa(code) {
    return this.send({
      method: 'GET',
      url: this.verifyUrl,
      params: _.merge({context: null, concise: true, useNetworkTags: true}, {code: code})
    }).then((data) => this.transformProfile(data));
  }

  get(paramOptions?) {
    return this.send({
      method: 'GET',
      url: this.url,
      params: _.merge({context: null, concise: true, useNetworkTags: true}, paramOptions)
    }).then((data) => this.transformProfile(data));
  }

  private transformProfile(data: any): any {
    if (_.isPlainObject(data?.profile)) {
      data.profile = _.mapValues(data.profile, (value: any) => {
        try {
          return JSON.parse(value);
        } catch (ex) {
          return value;
        }
      });
    }
    return data;
  }
}
